export default {
  account: () => import("/home/binaffan.com/nuxt-frontend/layouts/account.vue").then(m => m.default || m),
  admin: () => import("/home/binaffan.com/nuxt-frontend/layouts/admin.vue").then(m => m.default || m),
  default: () => import("/home/binaffan.com/nuxt-frontend/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/home/binaffan.com/nuxt-frontend/layouts/empty.vue").then(m => m.default || m),
  error: () => import("/home/binaffan.com/nuxt-frontend/layouts/error.vue").then(m => m.default || m)
}